/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SAPAccessCode
 */
export interface SAPAccessCode {
    /**
     * Representation of an SAP access code
     * @type {string}
     * @memberof SAPAccessCode
     */
    accessCode: string;
}

/**
 * Check if a given object implements the SAPAccessCode interface.
 */
export function instanceOfSAPAccessCode(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "accessCode" in value;

    return isInstance;
}

export function SAPAccessCodeFromJSON(json: any): SAPAccessCode {
    return SAPAccessCodeFromJSONTyped(json, false);
}

export function SAPAccessCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPAccessCode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accessCode': json['accessCode'],
    };
}

export function SAPAccessCodeToJSON(value?: SAPAccessCode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accessCode': value.accessCode,
    };
}

